/**
 * Language Switcher - 언어 선택 컴포넌트
 */

import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './LanguageSwitcher.css';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="language-switcher">
      <button
        className={`lang-btn ${language === 'en' ? 'active' : ''}`}
        onClick={() => setLanguage('en')}
        title="English"
      >
        🇬🇧 EN
      </button>
      <button
        className={`lang-btn ${language === 'ko' ? 'active' : ''}`}
        onClick={() => setLanguage('ko')}
        title="한국어"
      >
        🇰🇷 KO
      </button>
    </div>
  );
};

export default LanguageSwitcher;
